<template>
  <div class="block-wrapper">
    <div class="lesson-block main-block">
      <div class="lesson-block__user__frame">
        <template v-if="isPreviewImg">
          <div
            v-if="!isVideoStart"
            class="lesson-block__video-wrapper-preview"
          >
            <img :src="previewImg">
            <Icon
              class="width-40px position-absolute"
              icon="video-start"
              @click="startVideo"
            />
          </div>
          <div
            v-else
            class="lesson-block__video-wrapper"
          >
            <iframe
              class="lesson-block__video"
              :src="createVideoSrc + '?rel=0&amp;autoplay=1'"
              frameborder="0"
              allowfullscreen="allowfullscreen"
              allow="autoplay; encrypted-media; picture-in-picture"
            />
          </div>
        </template>
        <div
          v-else
          class="lesson-block__video-wrapper"
        >
          <iframe
            class="lesson-block__video"
            :src="createVideoSrc"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            allow="autoplay; encrypted-media; picture-in-picture"
          />
        </div>
      </div>
    </div>
    <div class="lesson-block lesson-block__video lesson-block__video--disclaimer">
      <div class="icon">
        <DisclaimerInfoIcon />
      </div>
      <p>
        В видео возможно упоминание Инстаграм и Фейсбук. Деятельность компании Meta Platforms Inc.,
        которой принадлежит Инстаграм / Фейсбук, запрещена на территории РФ в части реализации
        данных социальных сетей на основании осуществления ею экстремистской деятельности.
      </p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import matchServiceByUrl from '@/functions/matchServiceByUrl';
import DisclaimerInfoIcon from '@/components/Icons/DisclaimerInfoIcon';

export default {
  components: {
    DisclaimerInfoIcon
  },

  props: {
    content: {}
  },
  data: () => ({
    videoId: '',
    isPreviewImg: false,
    previewImg: '',
    isVideoStart: false
  }),
  computed: {
    createPosterSrc() {
      return `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`;
    },
    createVideoSrc() {
      if (this.typeId === 1) {
        return `https://www.youtube.com/embed/${this.videoId}`;
      }

      return `https://player.vimeo.com/video/${this.videoId}`;
    }
  },
  watch: {
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.videoId = this.getVideoId(this.content.videoUrl);
      if (this.content.img && this.content.img.url) {
        this.previewImg = this.content.img.url;
        this.isPreviewImg = true;
      }
      this.contentLocal = _.cloneDeep(this.content);
    },
    getVideoId(url) {
      const matchedService = matchServiceByUrl(url);
      this.isError = false;

      if (matchedService.name === 'vimeo') {
        this.typeId = 2;
        return matchedService.data[1].length >= 1 ? matchedService.data[1] : false;
      } else if (matchedService.name === 'youtube') {
        this.typeId = 1;
        return matchedService.data[1].length === 11 ? matchedService.data[1] : false;
      } else {
        this.isError = true;
        return null;
      }
    },
    startVideo() {
      this.isVideoStart = true;
    }
  }
};
</script>
